import PropTypes from "prop-types";

import {
  REQUEST_STATUS_LABEL,
  REQUEST_STATUS_BG,
  REQUEST_STATUS_FG,
} from "../constants/status";
import { RequestStatusT } from "../domain/types/requestStatus.types";

type StatusChipPropsT = {
  status: RequestStatusT;
  showBackground?: boolean;
};

const StatusChip = ({ status, showBackground = true }: StatusChipPropsT) => {
  const bgColor = REQUEST_STATUS_BG[status] || "bg-[#F5F5F5]";
  const dotColor = REQUEST_STATUS_FG[status] || "bg-[#9E9E9E]";
  const statusLabel = REQUEST_STATUS_LABEL[status] || "Desconocido";

  return (
    <output
      aria-label={`Estado: ${statusLabel}`}
      className={`${showBackground ? bgColor : ""} flex h-[1.75rem] min-w-[7rem] text-center items-center gap-[.75rem] px-[.75rem] rounded-full text-sm`}
    >
      <span
        className={`${dotColor} rounded-full w-[.5rem] h-[.5rem] shrink-0`}
      />
      {statusLabel}
    </output>
  );
};

StatusChip.propTypes = {
  status: PropTypes.string.isRequired,
  showBackground: PropTypes.bool,
};

export default StatusChip;
